import { InvoiceTranslations } from '../types/invoice';

export const invoiceTranslations: Record<'en' | 'nl' | 'fr' | 'es', InvoiceTranslations> = {
  en: {
    invoice: 'Invoice',
    invoiceNumber: 'Invoice Number',
    invoiceDate: 'Invoice Date',
    dueDate: 'Due Date',
    paymentTerms: 'Payment Terms',
    billTo: 'Bill To',
    description: 'Description',
    color: 'Color',
    sku: 'SKU',
    quantity: 'Qty',
    unitPrice: 'Unit Price',
    totalPrice: 'Total',
    subtotal: 'Subtotal (ex. VAT)',
    vat: 'VAT',
    total: 'Total Amount',
    paymentMethod: 'Payment Method',
    paymentStatus: 'Payment Status',
    paid: 'Paid',
    unpaid: 'Unpaid',
    overdue: 'Overdue',
    bankAccount: 'Bank Account',
    kvkNumber: 'Chamber of Commerce',
    vatNumber: 'VAT Number',
    termsAndConditions: 'Terms and Conditions',
    paymentInstructions: 'Payment Instructions'
  },
  nl: {
    invoice: 'Factuur',
    invoiceNumber: 'Factuurnummer',
    invoiceDate: 'Factuurdatum',
    dueDate: 'Vervaldatum',
    paymentTerms: 'Betalingstermijn',
    billTo: 'Factuuradres',
    description: 'Omschrijving',
    color: 'Kleur',
    sku: 'SKU',
    quantity: 'Aantal',
    unitPrice: 'Eenheidsprijs',
    totalPrice: 'Totaal',
    subtotal: 'Subtotaal (ex. BTW)',
    vat: 'BTW',
    total: 'Totaalbedrag',
    paymentMethod: 'Betaalmethode',
    paymentStatus: 'Betaalstatus',
    paid: 'Betaald',
    unpaid: 'Onbetaald',
    overdue: 'Achterstallig',
    bankAccount: 'Bankrekening',
    kvkNumber: 'KvK-nummer',
    vatNumber: 'BTW-nummer',
    termsAndConditions: 'Algemene Voorwaarden',
    paymentInstructions: 'Betaalinstructies'
  },
  fr: {
    invoice: 'Facture',
    invoiceNumber: 'Numéro de facture',
    invoiceDate: 'Date de facture',
    dueDate: 'Date d\'échéance',
    paymentTerms: 'Conditions de paiement',
    billTo: 'Facturer à',
    description: 'Description',
    color: 'Couleur',
    sku: 'SKU',
    quantity: 'Qté',
    unitPrice: 'Prix unitaire',
    totalPrice: 'Total',
    subtotal: 'Sous-total (HT)',
    vat: 'TVA',
    total: 'Montant total',
    paymentMethod: 'Mode de paiement',
    paymentStatus: 'Statut du paiement',
    paid: 'Payé',
    unpaid: 'Impayé',
    overdue: 'En retard',
    bankAccount: 'Compte bancaire',
    kvkNumber: 'Chambre de commerce',
    vatNumber: 'Numéro de TVA',
    termsAndConditions: 'Conditions générales',
    paymentInstructions: 'Instructions de paiement'
  },
  es: {
    invoice: 'Factura',
    invoiceNumber: 'Número de factura',
    invoiceDate: 'Fecha de factura',
    dueDate: 'Fecha de vencimiento',
    paymentTerms: 'Términos de pago',
    billTo: 'Facturar a',
    description: 'Descripción',
    color: 'Color',
    sku: 'SKU',
    quantity: 'Cant',
    unitPrice: 'Precio unitario',
    totalPrice: 'Total',
    subtotal: 'Subtotal (sin IVA)',
    vat: 'IVA',
    total: 'Importe total',
    paymentMethod: 'Método de pago',
    paymentStatus: 'Estado del pago',
    paid: 'Pagado',
    unpaid: 'Impago',
    overdue: 'Vencido',
    bankAccount: 'Cuenta bancaria',
    kvkNumber: 'Cámara de comercio',
    vatNumber: 'Número de IVA',
    termsAndConditions: 'Términos y condiciones',
    paymentInstructions: 'Instrucciones de pago'
  }
};

export const getPaymentMethodTranslation = (method: string, language: 'en' | 'nl'): string => {
  const translations = {
    en: {
      cash: 'Cash',
      pin: 'PIN/Card',
      bank_transfer: 'Bank Transfer',
      lowan: 'Lowan (Credit)'
    },
    nl: {
      cash: 'Contant',
      pin: 'PIN/Kaart',
      bank_transfer: 'Bankoverschrijving',
      lowan: 'Lowan (Krediet)'
    }
  };
  
  return translations[language][method as keyof typeof translations.en] || method;
};

export const formatCurrency = (amount: number, currency: string = 'EUR'): string => {
  return new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: currency
  }).format(amount);
};

export const formatDate = (date: string | Date, language: 'en' | 'nl'): string => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  const locale = language === 'nl' ? 'nl-NL' : 'en-GB';
  
  return dateObj.toLocaleDateString(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};